import { Typography } from '@mui/material'
import React from 'react'
import { BigPaper } from '../BigPaper/BigPaper'

export const Success = () => {
  return (
    <BigPaper
      elevation={0}
      style={{ width: '100%', maxWidth: 400, padding: 40, margin: '0 auto' }}
    >
      <Typography variant='h6' style={{ textAlign: 'center' }}>
        Registration Successful
      </Typography>
      <Typography
        variant='body1'
        color='textSecondary'
        style={{ textAlign: 'center' }}
      >
        Check your email to verify.
      </Typography>
    </BigPaper>
  )
}
